import {
  Briefcase, FileText, DollarSign, Scale, Cake,
  CalendarPlus, MessageSquare, TrendingUp, Percent,
  Phone, Mail, Globe, Instagram, Users, MessageCircle, MoreHorizontal
} from 'lucide-react';

export const CATEGORIAS_CONFIG = {
  abogados: {
    id: 'abogados',
    nombre: 'Tarea Abogados',
    icon: Briefcase,
    color: 'blue',
    bgColor: 'bg-blue-600',
    lightBg: 'bg-blue-50',
    textColor: 'text-blue-700',
    borderColor: 'border-l-blue-600'
  },
  minutas: {
    id: 'minutas',
    nombre: 'Tarea Minutas',
    icon: FileText,
    color: 'green',
    bgColor: 'bg-green-600',
    lightBg: 'bg-green-50',
    textColor: 'text-green-700',
    borderColor: 'border-l-green-600'
  },
  costas_pagar: {
    id: 'costas_pagar',
    nombre: 'Costas a Pagar',
    icon: DollarSign,
    color: 'orange',
    bgColor: 'bg-orange-600',
    lightBg: 'bg-orange-50',
    textColor: 'text-orange-700',
    borderColor: 'border-l-orange-600'
  },
  ejecuciones: {
    id: 'ejecuciones',
    nombre: 'Ejecuciones',
    icon: Scale,
    color: 'purple',
    bgColor: 'bg-purple-600',
    lightBg: 'bg-purple-50',
    textColor: 'text-purple-700',
    borderColor: 'border-l-purple-600'
  },
  pastelitos: {
    id: 'pastelitos',
    nombre: 'Pastelitos',
    icon: Cake,
    color: 'pink',
    bgColor: 'bg-pink-600',
    lightBg: 'bg-pink-50',
    textColor: 'text-pink-700',
    borderColor: 'border-l-pink-600'
  },
  citas_abogados: {
    id: 'citas_abogados',
    nombre: 'Cita Abogados',
    icon: CalendarPlus,
    color: 'indigo',
    bgColor: 'bg-indigo-600',
    lightBg: 'bg-indigo-50',
    textColor: 'text-indigo-700',
    borderColor: 'border-l-indigo-600'
  },
  atencion_cliente: {
    id: 'atencion_cliente',
    nombre: 'Atención Cliente',
    icon: MessageSquare,
    color: 'cyan',
    bgColor: 'bg-cyan-600',
    lightBg: 'bg-cyan-50',
    textColor: 'text-cyan-700',
    borderColor: 'border-l-cyan-600'
  },
  propuestas_intereses: {
    id: 'propuestas_intereses',
    nombre: 'Propuestas Intereses',
    icon: TrendingUp,
    color: 'teal',
    bgColor: 'bg-teal-600',
    lightBg: 'bg-teal-50',
    textColor: 'text-teal-700',
    borderColor: 'border-l-teal-600'
  },
  cobrettis: {
    id: 'cobrettis',
    nombre: 'COBRETTIS',
    icon: DollarSign,
    color: 'text-green-600',
    bgColor: 'bg-green-50',
  },
  honorarios: {
    id: 'honorarios',
    nombre: 'HONORARIOS',
    icon: Percent,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
  },
};

export const PRIORIDADES = {
  baja: { nombre: 'Baja', color: 'bg-gray-100 text-gray-700' },
  media: { nombre: 'Media', color: 'bg-blue-100 text-blue-700' },
  alta: { nombre: 'Alta', color: 'bg-orange-100 text-orange-700' },
  urgente: { nombre: 'Urgente', color: 'bg-red-100 text-red-700 animate-pulse' }
};

export const FASES_MINUTAS = {
  fase_a: { nombre: 'Fase A - Solicitud', color: 'bg-yellow-100 text-yellow-800', icon: '\ud83d\udcdd' },
  fase_b: { nombre: 'Fase B - Tramitación', color: 'bg-blue-100 text-blue-800', icon: '\ud83d\udce4' },
  fase_c: { nombre: 'Fase C - Finalización', color: 'bg-green-100 text-green-800', icon: '\u2705' }
};

export const TIPOS_COSTAS = [
  { value: 'costas_1a_instancia', label: 'Costas de 1a instancia' },
  { value: 'costas_2a_instancia', label: 'Costas de 2a instancia' },
  { value: 'costas_3a_instancia', label: 'Costas de 3a instancia' },
  { value: 'costas_impugnacion', label: 'Costas incidente impugnación de costas' },
  { value: 'costas_ejecucion', label: 'Costas ejecución' },
  { value: 'costas_oposicion_ejecucion', label: 'Costas oposición ejecución' },
  { value: 'otras_costas', label: 'Otras costas' }
];

export const ESTADOS_PROPUESTA_INTERESES = [
  { value: 'pendiente', label: 'Pendiente de realizar', color: 'bg-orange-100 text-orange-700' },
  { value: 'realizada', label: 'Realizada propuesta para supervisar y enviar', color: 'bg-blue-100 text-blue-700' },
  { value: 'revisada', label: 'Revisada y presentada propuesta final al juzgado', color: 'bg-green-100 text-green-700' },
  { value: 'no_necesaria', label: 'No realizada', color: 'bg-red-100 text-red-700' },
  { value: 'pendiente', label: 'Pendiente realizar propuesta', color: 'bg-orange-100 text-orange-700' }
];

export const ORIGENES = {
  telefono: { nombre: 'Teléfono', icon: Phone, color: 'bg-green-100 text-green-700' },
  email: { nombre: 'Email', icon: Mail, color: 'bg-blue-100 text-blue-700' },
  whatsapp: { nombre: 'WhatsApp', icon: MessageSquare, color: 'bg-emerald-100 text-emerald-700' },
  web: { nombre: 'Web', icon: Globe, color: 'bg-purple-100 text-purple-700' },
  instagram: { nombre: 'Instagram', icon: Instagram, color: 'bg-pink-100 text-pink-700' }
};

export const ESTADOS_CONSULTA = {
  en_proceso: { nombre: 'En Proceso', color: 'bg-blue-100 text-blue-700' },
  completado: { nombre: 'Completado', color: 'bg-green-100 text-green-700' }
};

export const CANALES_ENTRADA = {
  presencial: { nombre: 'Presencial', icon: Users, color: 'bg-blue-100 text-blue-700' },
  telefono: { nombre: 'Teléfono', icon: Phone, color: 'bg-green-100 text-green-700' },
  email: { nombre: 'Email', icon: Mail, color: 'bg-purple-100 text-purple-700' },
  whatsapp: { nombre: 'WhatsApp', icon: MessageCircle, color: 'bg-emerald-100 text-emerald-700' },
  web: { nombre: 'Web', icon: Globe, color: 'bg-indigo-100 text-indigo-700' },
  instagram: { nombre: 'Instagram', icon: Instagram, color: 'bg-pink-100 text-pink-700' },
  otro: { nombre: 'Otro', icon: MoreHorizontal, color: 'bg-gray-100 text-gray-700' }
};

export const ESTADOS_CITA = {
  pendiente: { nombre: 'Pendiente', color: 'bg-yellow-100 text-yellow-700' },
  propuesta: { nombre: 'Propuesta', color: 'bg-blue-100 text-blue-700' },
  confirmada: { nombre: 'Confirmada', color: 'bg-green-100 text-green-700' },
  realizada: { nombre: 'Realizada', color: 'bg-gray-100 text-gray-700' },
  cancelada: { nombre: 'Cancelada', color: 'bg-red-100 text-red-700' },
  no_presentado: { nombre: 'No presentado', color: 'bg-orange-100 text-orange-700' }
};
